module.exports = __webpack_public_path__ + "static/media/3DPPA40.82b66a06.jpg";